import {SettingParamTypes, FlowNodeData, FlowNodeTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const speakNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.SPEAK,
  position: {x: 0, y: 0},
  measured: {height: 115, width: 340},
  data: {
    type: FlowNodeTypes.SPEAK,
    settingsTitle: "Speak",
    nodeTitle: "Speak",
    description: "This is the speak node",
    onChange: () => {
      console.log("Speak node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "General",
        expandedSetting: true,
        params: [
          {
            type: SettingParamTypes.INPUT,
            key: "name",
            value: "",
            placeholder: "Enter a name for the speak node",
          },
          {
            type: SettingParamTypes.TABS,
            key: "verbatim",
            value: {},
            tabs: [
              {
                title: "AI Prompt",
                value: [],
                key: "ai_prompt",
                settings: [],
              },
              {
                title: "Exact Message",
                value: "",
                key: "exact_message",
                settings: [],
              },
            ],
          },
          {
            label: "Message",
            placeholder:
              "Give some instructions on what the AI agent should say here.",
            type: SettingParamTypes.PROMPT,
            key: "instructions",
            tooltipMessage:
              "Choose what the agent will say. Once spoken, the agent will move onto the next node in the graph.",
            value: "",
          },
        ],
      },
    ],
  },
};
